import { type GenericMap } from "@common/declarations";
import * as stripeJs from "@stripe/stripe-js";

export const getStripeInputStyle = (
  style: React.CSSProperties
): { input: GenericMap<any>; placeholder: GenericMap<any> } => ({
  input: {
    color: style.color,
    fontFamily: style.fontFamily,
    fontSize: typeof style.fontSize === "number" ? `${style.fontSize}px` : style.fontSize,
    fontStyle: style.fontStyle,
    fontWeight: style.fontWeight,
    lineHeight: typeof style.lineHeight === "number" ? `${style.fontSize}px` : style.lineHeight
  },
  placeholder: {
    color: style.color,
    fontFamily: style.fontFamily,
    fontSize: typeof style.fontSize === "number" ? `${style.fontSize}px` : style.fontSize,
    fontStyle: style.fontStyle,
    fontWeight: style.fontWeight
  }
});

export const initStripe = (publishKey: string): Promise<stripeJs.Stripe> => {
  const key = `stripePromise-${publishKey}`;
  if (!window[key]) {
    window[key] = new Promise<stripeJs.Stripe>((resolve) => {
      const script = document.createElement("script");

      script.src = "https://js.stripe.com/v3/";
      script.async = true;
      script.onload = () => {
        resolve(window.Stripe!(publishKey));
      };

      document.body.appendChild(script);
    });
  }
  return window[key];
};

export type StripeCustomerInfo = {
  email: string;
  firstName?: string | null;
  lastName?: string | null;
};

export type SetupIntent = {
  clientSecret: string;
  customerId: string;
  id: string;
};

export type PaymentIntent = {
  clientSecret: string;
  customerId: string;
  id: string;
};
